module.exports = __webpack_public_path__ + "static/media/bright-bg-long.9bf426b8.png";